import $ from 'jquery';

export const createCrossSellPicker = (section, { add, rememberNonce, isBusy, inline = false, onToggle = () => {} }) => {
    const dialog = section.querySelector('[data-cross-sell-picker]');
    const content = dialog.querySelector('[data-cross-sell-picker-content]');
    const closeButton = dialog.querySelector('[data-cross-sell-close]');
    let origin = null;
    let state = null;
    let request = null;
    let variants = [];
    let selection = null;
    let baseImage = '';
    let basePrice = '';
    let imageKey = '';
    let closing = false;
    let closeTimer = null;
    let active = false;
    let destroyed = false;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const status = (message, error = false, available = false) => {
        const target = content.querySelector('[data-picker-status]');
        if (!target) return;
        target.textContent = message;
        target.classList.toggle('is-error', error);
        target.classList.toggle('is-available', available);
    };
    const update = () => {
        const form = content.querySelector('form');
        if (!form) return;
        const groups = [...form.querySelectorAll('[data-picker-attribute]')];
        const attributes = Object.fromEntries(groups.map((group) => [group.dataset.attributeName, group.querySelector('input:checked')?.value || '']));
        const matches = (variant, values) => Object.entries(values).every(([name, value]) => !value || !variant.attributes[name] || variant.attributes[name] === value);
        groups.forEach((group) => {
            const name = group.dataset.attributeName;
            const others = { ...attributes };
            delete others[name];
            group.querySelectorAll('[data-picker-option]').forEach((input) => {
                const available = variants.some((variant) => variant.available && matches(variant, { ...others, [name]: input.value }));
                input.disabled = !available || isBusy() || state.retry;
                const label = input.closest('label');
                label.classList.toggle('is-unavailable', !available);
                label.title = `${input.dataset.label}${available ? '' : ' — niedostępny'}`;
                input.setAttribute('aria-label', label.title);
            });
            const selected = group.querySelector('input:checked');
            group.querySelector('[data-picker-selected]').textContent = selected ? `: ${selected.dataset.label}` : '';
        });
        const complete = groups.every((group) => attributes[group.dataset.attributeName]);
        const variant = complete ? variants.find((value) => value.available && matches(value, attributes)) : null;
        selection = variant ? {
            ...variant,
            attributes,
            label: groups.map((group) => group.querySelector('input:checked').dataset.label).join(' · '),
        } : null;
        content.querySelector('[data-picker-price]').innerHTML = variant ? variant.price : basePrice;
        const nextImageKey = variant ? String(variant.id) : 'base';
        if (imageKey !== nextImageKey) {
            imageKey = nextImageKey;
            content.querySelector('[data-picker-image]').innerHTML = variant ? variant.image : baseImage;
        }
        const submit = form.querySelector('[type="submit"]');
        submit.disabled = isBusy() || (!state.retry && !selection);
        submit.querySelector('[data-picker-submit-label]').textContent = state.retry ? 'Spróbuj ponownie' : 'Dodaj do koszyka';
        const submitPrice = submit.querySelector('[data-picker-submit-price]');
        submitPrice.hidden = !selection;
        submitPrice.innerHTML = selection ? selection.amount_html : '';
        content.querySelector('[data-picker-clear]').disabled = isBusy() || state.retry || !groups.some((group) => group.querySelectorAll('input').length > 1 && group.querySelector('input:checked'));
        if (state.retry) status('Nie udało się potwierdzić dodania. Ponów ten sam wybór, aby sprawdzić koszyk.', true);
        else if (!variants.some((value) => value.available)) status('Ten produkt jest obecnie niedostępny.', true);
        else if (!complete) {
            const missing = groups.filter((group) => !attributes[group.dataset.attributeName]).map((group) => group.dataset.attributeLabel.toLocaleLowerCase('pl'));
            status(`Wybierz: ${missing.join(' i ')}.`);
        }
        else if (!selection) status('Ta kombinacja jest niedostępna. Wybierz inne opcje.', true);
        else status(variant.stock_note || 'Dostępny', false, true);
    };
    const resetAfterClose = () => {
        if (!active) return;
        active = false;
        clearTimeout(closeTimer);
        closeTimer = null;
        dialog.classList.remove('is-closing');
        dialog.inert = false;
        closing = false;
        if (!inline) document.documentElement.classList.remove('has-cross-sell-picker');
        onToggle(false);
        if (!destroyed) origin?.querySelector(state?.key ? '[data-cross-sell-undo]' : '[data-cross-sell-add]').focus({ preventScroll: true });
    };
    const finishClose = () => {
        dialog.inert = false;
        dialog.close();
        resetAfterClose();
    };
    const close = () => {
        if (isBusy() || closing || !dialog.open) return;
        const pending = request;
        request = null;
        if (pending) pending.abort();
        if (inline || reducedMotion.matches) { finishClose(); return; }
        // Start from the current frame when Escape interrupts the entrance animation.
        const frame = getComputedStyle(dialog);
        dialog.style.setProperty('--picker-close-opacity', frame.opacity);
        dialog.style.setProperty('--picker-close-transform', frame.transform);
        dialog.style.setProperty('--picker-backdrop-opacity', getComputedStyle(dialog, '::backdrop').opacity);
        closing = true;
        dialog.inert = true;
        dialog.classList.add('is-closing');
        // Keep the native modal and scroll lock until both the panel and backdrop fade out.
        closeTimer = setTimeout(finishClose, 240);
    };
    const open = (card, cardState) => {
        if (closing || destroyed) return;
        if (request) request.abort();
        origin = card;
        state = cardState;
        selection = null;
        imageKey = '';
        content.innerHTML = '<p class="ProductCrossSellPicker__status" role="status">Wczytujemy dostępne warianty…</p>';
        if (!dialog.open) {
            active = true;
            onToggle(true);
            if (inline) dialog.show();
            else dialog.showModal();
        }
        if (!inline) document.documentElement.classList.add('has-cross-sell-picker');
        closeButton.focus({ preventScroll: true });
        const current = $.ajax({
            url: jsData.ajaxUrl, type: 'GET', dataType: 'json', cache: false, timeout: 20000,
            data: { action: 'ravessa_sidebar_product', product_id: card.dataset.productId, view: 'cross_sell' },
        });
        request = current;
        const fail = (message) => {
            content.innerHTML = '<p class="ProductCrossSellPicker__status is-error" role="alert"></p><button type="button" class="Button--no-style ProductCrossSellPicker__retry" data-picker-retry>Spróbuj ponownie</button>';
            content.querySelector('p').textContent = message || 'Nie udało się wczytać wariantów. Sprawdź połączenie i spróbuj ponownie.';
        };
        current.done((response) => {
            if (request !== current || !dialog.open) return;
            if (!response.success || typeof response.data?.html !== 'string') { fail(response.data?.message); return; }
            content.innerHTML = response.data.html;
            // The page and confirmation can both contain a picker: keep label/status IDs unique.
            const ids = new Map();
            content.querySelectorAll('[id]').forEach((element) => {
                ids.set(element.id, `${section.id}-${element.id}`);
                element.id = ids.get(element.id);
            });
            content.querySelectorAll('[for], [aria-describedby], [aria-controls], [aria-labelledby]').forEach((element) => {
                ['for', 'aria-describedby', 'aria-controls', 'aria-labelledby'].forEach((attribute) => {
                    if (element.hasAttribute(attribute)) element.setAttribute(attribute, element.getAttribute(attribute).split(' ').map((id) => ids.get(id) || id).join(' '));
                });
            });
            variants = response.data.variants || [];
            rememberNonce(response.data.nonce);
            baseImage = content.querySelector('[data-picker-image]').innerHTML;
            basePrice = content.querySelector('[data-picker-price]').innerHTML;
            if (state.selection) content.querySelectorAll('[data-picker-option]').forEach((input) => {
                input.checked = input.value === state.selection.attributes[input.name];
            });
            update();
            const groups = [...content.querySelectorAll('[data-picker-attribute]')];
            const firstGroup = groups.find((group) => !group.querySelector('input:checked')) || groups[0];
            (firstGroup?.querySelector('input:checked:not(:disabled)') || firstGroup?.querySelector('input:not(:disabled)') || closeButton).focus({ preventScroll: true });
        }).fail((xhr, result) => {
            if (request === current && result !== 'abort') fail(xhr.responseJSON?.data?.message);
        }).always(() => { if (request === current) request = null; });
    };

    closeButton.addEventListener('click', close);
    dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        close();
    });
    dialog.addEventListener('animationend', (event) => {
        if (closing && event.target === dialog && event.animationName === 'cross-sell-picker-out') finishClose();
    });
    dialog.addEventListener('close', () => {
        // Native close events are queued; an old event must not cancel a fresh opening.
        if (dialog.open) return;
        if (request) request.abort();
        request = null;
        resetAfterClose();
    });
    dialog.addEventListener('click', (event) => {
        if (event.target === dialog) {
            const bounds = dialog.getBoundingClientRect();
            if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
        }
        if (event.target.closest('[data-picker-retry]')) open(origin, state);
    });
    content.addEventListener('click', (event) => {
        if (!event.target.closest('[data-picker-clear]') || isBusy() || state.retry) return;
        content.querySelectorAll('[data-picker-attribute]').forEach((group) => {
            const inputs = group.querySelectorAll('[data-picker-option]');
            if (inputs.length > 1) inputs.forEach((input) => { input.checked = false; });
        });
        update();
        content.querySelector('[data-picker-option]:not(:disabled)')?.focus({ preventScroll: true });
    });
    content.addEventListener('change', update);
    content.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (isBusy()) return;
        update();
        if (!state.retry && (!selection || !event.target.reportValidity())) return;
        closeButton.disabled = true;
        const pending = add(origin, state.retry ? state.pendingSelection : selection);
        content.querySelectorAll('[data-picker-option], [data-picker-clear], [type="submit"]').forEach((input) => { input.disabled = true; });
        content.querySelector('[data-picker-submit-label]').textContent = 'Dodajemy…';
        status('Dodajemy produkt do koszyka…');
        const result = await pending;
        closeButton.disabled = false;
        if (result.success) close();
        else {
            update();
            status(result.message, true);
        }
    });
    return {
        open, close, isOpen: () => dialog.open,
        destroy: () => {
            destroyed = true;
            if (request) request.abort();
            request = null;
            clearTimeout(closeTimer);
            if (dialog.open) finishClose();
        },
    };
};
